export default {
	"order.MallOpeningRecordPage": "商城开通记录页",
	"order.PhasesOpened": "已开通期数：",
	"order.StoreOpeningRecordPageBuyTheNextIssueClick": "商城开通记录页_购买下期点击",
	"order.buyNextIssue": "购买下期",
	"order.DebitRecord": "扣款记录",
	"order.No": "第",
	"order.Expect": "期",
	"order.DebitSuccess": "扣款成功",
	"order.D": "扣款金额：",
	"order.PaymentSerialNumber": "支付流水号：",
	"order.PaymentTime": "支付时间：",
	"order.UnfortunatelyNoMatchingDataWasFound": "非常遗憾，没有找到符合条件的数据"
}